export const aguaProducts = [
  {
    id: 1,
    name: 'Cachantún con gas 600 ml',
    image: 'https://public.readdy.ai/ai/img_res/0be24ce4-7b67-401f-9c0b-13d0552721aa.png',
    unitsPerPack: 12,
    packagingType: 'Display',
    unitPrice: 430,
    packPrice: 3360,
    palletPrice: null
  },
  {
    id: 2,
    name: 'Benedictino con gas 500 ml',
    image: 'https://public.readdy.ai/ai/img_res/ee28c654-8445-4108-96ff-23afdb080dd0.png',
    unitsPerPack: 12,
    packagingType: 'Display',
    unitPrice: 430,
    packPrice: 3360,
    palletPrice: null
  },
  {
    id: 3,
    name: 'Cachantún con gas 1.6 L',
    image: 'https://public.readdy.ai/ai/img_res/5a8293e0-11df-4b39-9690-087612e3f847.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 880,
    packPrice: 4380,
    palletPrice: null
  },
  {
    id: 4,
    name: 'Agua Score con gas 500 ml',
    image: 'https://public.readdy.ai/ai/img_res/6fedc678-045b-4ff5-8c92-893c72a8315c.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 600,
    packPrice: 7200,
    palletPrice: null
  },
  {
    id: 5,
    name: 'Agua Vital con gas 600 ml',
    image: 'https://public.readdy.ai/ai/img_res/bbfecd2f-ab33-421b-83a7-6477648d1ab2.png',
    unitsPerPack: 12,
    packagingType: 'Display',
    unitPrice: 455,
    packPrice: 3960,
    palletPrice: null
  },
  {
    id: 6,
    name: 'Cachantún sin gas 600 ml',
    image: 'https://public.readdy.ai/ai/img_res/3b7b4b8a-444c-4bd0-9b29-5c74e268f756.png',
    unitsPerPack: 12,
    packagingType: 'Display',
    unitPrice: 430,
    packPrice: 3360,
    palletPrice: null
  },
  {
    id: 7,
    name: 'Benedictino sin gas 500 ml',
    image: 'https://public.readdy.ai/ai/img_res/580c9e98-6eb5-4802-9d78-4bc0a6c1d156.png',
    unitsPerPack: 12,
    packagingType: 'Display',
    unitPrice: 430,
    packPrice: 3360,
    palletPrice: null
  },
  {
    id: 8,
    name: 'Cachantún sin gas 1.6 L',
    image: 'https://public.readdy.ai/ai/img_res/a3aff160-1270-4407-95fd-a57063d672fb.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 880,
    packPrice: 4380,
    palletPrice: null
  },
  {
    id: 9,
    name: 'Agua Vital sin gas 600 ml',
    image: 'https://public.readdy.ai/ai/img_res/8cb9478e-f8a6-40c2-a53d-b7abb6599f7e.png',
    unitsPerPack: 12,
    packagingType: 'Display',
    unitPrice: 455,
    packPrice: 3960,
    palletPrice: null
  },
  {
    id: 10,
    name: 'Agua Score sin gas 500 ml',
    image: 'https://public.readdy.ai/ai/img_res/20e923d8-493b-4714-b42a-5a7f048fb2e7.png',
    unitsPerPack: 24,
    packagingType: 'Bandeja',
    unitPrice: 600,
    packPrice: 7200,
    palletPrice: null
  }
];
